import { getDefaultShopConfig } from './default';
import { getConditionsFilterConfig } from '../filters/condition';
import * as custom from '../filters/marketplace-custom-config';
import { getSizeFilterConfig } from '../filters/size';
import { getColorFilterConfig } from '../filters/color';
import { getBrandDirectFilterConfig } from '../filters/brandDirect';

const astrthelabelSizes = ['XS', 'S', 'M', 'L', 'XL', '1X', '2X', '3X'];

export const astrthelabelShopConfig = {
  ...getDefaultShopConfig(),
  filters: [
    ...custom.filters,
    getConditionsFilterConfig(),
    getSizeFilterConfig({ sizes: astrthelabelSizes }),
    getColorFilterConfig(),
    getBrandDirectFilterConfig(),
  ],
};
